"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = void 0;
const tslib_1 = require("tslib");
const fetchHelper_1 = tslib_1.__importDefault(require("../../../common/fetchHelper"));
class HttpClient {
    createTimeoutSignal(ms) {
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), ms);
        return { signal: controller.signal, clear: () => clearTimeout(id) };
    }
    async get(url, options = {}) {
        const { timeout = 30000, progress } = options;
        const { signal, clear } = this.createTimeoutSignal(timeout);
        try {
            const res = await (0, fetchHelper_1.default)(url, {
                redirect: "follow",
                follow: options.maxRedirects ?? 5,
                signal: signal,
            });
            if (!res.ok) {
                throw new Error(`Request failed with status ${res.status}`);
            }
            const totalSize = parseInt(res.headers.get("content-length") || "0", 10);
            let downloaded = 0;
            const chunks = [];
            for await (const chunk of res.body) {
                chunks.push(chunk);
                downloaded += chunk.length;
                if (progress) {
                    progress(downloaded, totalSize);
                }
            }
            const buffer = Buffer.concat(chunks);
            return buffer;
        }
        finally {
            clear();
        }
    }
    async getText(url, options = {}) {
        const buffer = await this.get(url, options);
        return buffer.toString("utf-8");
    }
    async headTime(url, options = {}) {
        const { timeout = 30000 } = options;
        const { signal, clear } = this.createTimeoutSignal(timeout);
        try {
            const startTime = Date.now();
            const res = await (0, fetchHelper_1.default)(url, {
                method: "HEAD",
                signal: signal,
            });
            if (!res.ok) {
                throw new Error(`Request failed with status ${res.status}`);
            }
            return Date.now() - startTime;
        }
        finally {
            clear();
        }
    }
}
exports.httpClient = new HttpClient();
//# sourceMappingURL=httpClient.js.map